export default function OrderMenuIcon(props) {
  return (
    <svg
      viewBox="-2 -2 28 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99902 9.74964L11.999 8.74964L13.999 9.74964V4.99963H9.99902V9.74964ZM6.99902 16.9996V14.9996H11.999V16.9996H6.99902ZM4.99902 20.9996C4.44902 20.9996 3.97819 20.8038 3.58652 20.4121C3.19486 20.0205 2.99902 19.5496 2.99902 18.9996V4.99963C2.99902 4.44963 3.19486 3.9788 3.58652 3.58713C3.97819 3.19547 4.44902 2.99963 4.99902 2.99963H18.999C19.549 2.99963 20.0199 3.19547 20.4115 3.58713C20.8032 3.9788 20.999 4.44963 20.999 4.99963V18.9996C20.999 19.5496 20.8032 20.0205 20.4115 20.4121C20.0199 20.8038 19.549 20.9996 18.999 20.9996H4.99902ZM4.99902 18.9996H18.999V4.99963H15.999V12.9996L11.999 10.9996L7.99902 12.9996V4.99963H4.99902V18.9996Z"
        fill="currentColor"
      />
    </svg>
  );
}
